<!-- Объекты верх -->
<div class="tabpage objects" [attr.id]="rootID" *ngIf="!hiddenMode">
  <app-objects-filter></app-objects-filter>
  <div class="choosegroup dropdown dropclick" [attr.id]="groupRootID">
    <input type="text" readonly="readonly" />
    <div class="dropcontent dontclose">
      <div class="dropcontentinset">
        <!-- button class="btnaddgroup">{{ 'Add' | translate }}</button-->
        <input type="text" class="searchinput" placeholder="{{ 'Group search'| translate }}" />
        <ul></ul>
      </div>
    </div>
    <div class="objdropdown dropdown dropclick dropclickjs">
      <ul>
        <li>{{ 'Select' | translate }}</li>
      </ul>
    </div>
  </div>
  <div class="tableheader">
    <input type="checkbox">
    <label class="check_img check_sortaz" title="{{ 'Sorting order' | translate }}"><input type="checkbox"><span></span></label>

    <label *ngIf="trackingMode" class="check_img check_wifi" title="{{ 'Show only online devices' | translate }}"><input type="checkbox"><span></span></label>
    <label *ngIf="trackingMode" class="check_img check_alert" title="{{ 'Show only devices with alarms' | translate }}"><input type="checkbox"><span></span></label>
    <label *ngIf="trackingMode" class="check_img check_parking" title="{{ 'Show only parked devices' | translate }}"><input type="checkbox"><span></span></label>
    <label *ngIf="trackingMode" class="check_img check_speed" title="{{ 'Show only moving devices' | translate }}"><input type="checkbox"><span></span></label>
  </div>
  <div class="tablewrap">
    <div class="table">
      <table [attr.id]="listRootID">
      </table>
      <div class="objdropdown dropdown dropclick dropclickjs devicemenu">
        <ul>
          <li>{{ 'Show on the map' | translate }}</li>
          <li>{{ 'Send command to device' | translate }}</li>
          <li>{{ 'Show photos from device' | translate }}</li>
          <li class="separator" *ngIf="canAccessComponent(AccessRights.EDIT)"></li>
          <li class="edit_object" *ngIf="canAccessComponent(AccessRights.EDIT)">{{ 'Edit' | translate }}</li>
          <li class="sync_object" *ngIf="canAccessComponent(AccessRights.EDIT)">{{ 'Synchronize keys' | translate }}</li>
        </ul>
      </div>
    </div>
  </div>

  <app-pagination [viewmode]="'pages hideitemscount'" [ngClass]="pagerClass"></app-pagination>
</div>
